import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=0435c53a&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseAlert.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=0435c53a&prod&lang=css"
import style1 from "./BaseAlert.vue?vue&type=style&index=1&id=0435c53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435c53a",
  null
  
)

export default component.exports